import { Table, TableBody, TableRow, TableCell } from "@mui/material"
import CheckIcon from '@mui/icons-material/Check';
import { BalllotReviewProps } from "../types";
import { sortResult } from "../../pages/election/util";
import { CandidateImage, CandidateName } from "../../components/candidate-image";
import { PreferenceVote } from "../preference/preference-typedef";
import { CANDIDATE_DISPLAY_FORMAT } from "../../domain/ballot-api";
import { useCallback } from "react";
import { CANDIDATE_STATUS, ICandidate } from "../../domain/candidate";
import { useGetCandidate } from "../../util/candidates";

export const FirstPastReview = ({ response, question }: BalllotReviewProps<PreferenceVote>) => {
    const ranking = Object.values(response).filter((v) => v.index !== null);
    const { candidate_display_format } = question;

    const getCandidate = useGetCandidate(question.candidates)
    ranking.sort(sortResult);
    return (
        <Table size="small">
            <TableBody>
                {ranking.map((r, i) => (
                    <TableRow key={i}>
                        <TableCell align="center" width={20}>
                            <CheckIcon />
                        </TableCell>
                        <TableCell>
                            <CandidateName candidate={getCandidate(r.id)} />
                        </TableCell>
                        {candidate_display_format === CANDIDATE_DISPLAY_FORMAT.IMAGE_PRIORITY ?
                            <TableCell><CandidateImage candidate={getCandidate(r.id)} /></TableCell>
                            : null
                        }
                    </TableRow>
                ))}
            </TableBody>
        </Table>
    )
}